import { tss } from "tss-react/mui";

export const useRelatedArticlesSectionStyles = tss.withName("RelatedArticlesSection").create(({ theme }) => ({
    root: {
        backgroundColor: theme.palette.primary[50],
    },
    title: {
        marginBottom: theme.spacing(4),
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: theme.spacing(4),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
        },
    },
}));
